import React from 'react';
import '../../Property.css';

import { TextField } from 'redux-form-material-ui';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';

import validate from './validate';

import { deepDiver } from 'helpers/utilities';
import { AccentColor } from 'helpers/AccentColorHelper';

const styles = {
  button: {
    color: 'white',
    float: 'right',
    height: '40px',
  },
  backButton: {
    float: 'left',
    color: AccentColor(),
    height: '40px',
  },
  dropzoneBox: {
    height: '200px',
    width: '200px',
    float: 'none',
    display: 'block',
    margin: '15px auto 0px auto',
  },
  dropzoneButton: {
    width: '200px',
    margin: '25px auto 25px auto',
    display: 'block',
  },
  avatar: {
    height: '200px',
    width: '200px',
    float: 'right',
    border: '0px solid #e1e1e1',
    boxShadow: 'none',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: '50% 0',
  },
  addPhoto: {
    fontSize: '40px',
    color: '#9e9e9e',
    opacity: '0.9',
  },
  propertyName: {
    fontSize: '14px',
    margin: '25px auto 25px auto',
    display: 'block',
  },
  center: {
    margin: '0px auto 0px auto',
    display: 'block',
  },
};

let NameAndImage = props => {
  const { handleSubmit } = props;

  return (
    <div>
      <h3 style={{ textAlign: 'center', marginBottom: '10px' }}> Property Name </h3>
      <form onSubmit={handleSubmit} encType="multipart/form-data">
        <div className="row">
          <p style={{ textAlign: 'center', marginBottom: '25px' }}>
            Your property nickname will be shown throughout the application for easy reference.
          </p>
          <Field
            name="name"
            component={TextField}
            hintText="Property Nickname"
            fullWidth
            style={styles.propertyName}
          />
        </div>
        <div className="row">
          <p style={{ textAlign: 'center', marginBottom: '25px' }}>
            Your property legal name will be used when signing leases and all other legal
            documentation. If you use the same company legal name for each property, you can leave
            this blank.
          </p>
          <Field
            name="legal_name"
            component={TextField}
            hintText="Property Legal Name"
            fullWidth
            style={styles.propertyName}
          />
        </div>
      </form>
    </div>
  );
};

NameAndImage = reduxForm({
  form: 'add_property',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate,
})(NameAndImage);

NameAndImage = connect(state => ({
  initialValues: {
    name: deepDiver(state, 'form.add_property.values.name'),
    legal_name: deepDiver(state, 'form.add_property.values.legal_name'),
  },
}))(NameAndImage);
export default NameAndImage;
